export default __webpack_public_path__ + "static/media/Histopathology.125f4761.svg";